<template>
  <div
    class="flex mb-2"
    data-qa="offer-different-price-radio"
    no-gutters>
    <RadioGroup
      class="mr-5 new_price_variants my-auto"
      data-qa="offer-different-price-radio-block"
      :items="price_modes"
      label_class="h7-text"
      :model.sync="radio_value"
      row
      @change="changeMode"/>
    <OfferDifferentPriceInput
      ref="input"
      :currency="currency"
      :error.sync="value_error"
      :form-item="isMultiple ? '' : formItem"
      :type.sync="radio_value"
      :value.sync="text_value"
      @change="changePrice"/>
  </div>
</template>
<script>
import RadioGroup from 'components/common/inputs/RadioGroup.vue'
import OfferDifferentPriceInput from 'components/tenders/tender page/offer different price/OfferDifferentPriceInput.vue'

export default {
  name: 'offerDifferentPriceRadio',
  props: {
    model_text: [String, Number],
    model_radio: [String, Number],
    error: Boolean,
    currency: String,
    formItem: String,
    isSale: Boolean,
    isMultiple: Boolean
  },
  computed: {
    text_value: {
      get() {
        return this.model_text
      },
      set(value) {
        this.$emit('update:model_text', value)
      }
    },
    value_error: {
      get() {
        return this.error
      },
      set(value) {
        this.$emit('update:error', value)
      }
    },
    radio_value: {
      get() {
        return this.model_radio
      },
      set(value) {
        this.$emit('update:model_radio', value)
      }
    },
    price_modes() {
      let sign = this.isSale ? '+' : '-',
        result = [
          {
            value: 1 ,
            label: sign + '1%'
          },
          {
            value: 2,
            label: sign + '2%'
          },
          {
            value: 'PRICE',
            label: this.$t('Tenders.MyPrice') + ', ' + this.currency
          },
          {
            value: 'PERSENT',
            label: this.$t('Tenders.MyValue') + ', %'
          }
        ]
      return result
    }
  },
  methods: {
    changeMode(mode) {
      this.$refs.input.clearValidate()
      let changeText = (text) => {
        this.$nextTick(() => {
          this.$emit('changePrice', text, this.radio_value)
          this.$emit('changeMode', mode)
        })
      }
      if ( mode == 1 || mode == 2 ) {
        this.text_value = mode
        changeText(mode)
        return
      }

      changeText(this.text_value)
    },
    changePrice(text) {
      this.$emit('changePrice', text, this.radio_value)
    },
  },
  components: {
    RadioGroup,
    OfferDifferentPriceInput
  }
}
</script>
